import { render, staticRenderFns } from "./nvar.vue?vue&type=template&id=121b6e09&scoped=true&"
import script from "./nvar.vue?vue&type=script&lang=js&"
export * from "./nvar.vue?vue&type=script&lang=js&"
import style0 from "./nvar.vue?vue&type=style&index=0&id=121b6e09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121b6e09",
  null
  
)

export default component.exports